import { NetworkProductConfigurationCluster } from "src/app/ui/models/domains/pbm/Benefit/network-product-configuration";
import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { Network } from "src/app/ui/models/domains/pbm/Benefit/network";

@Injectable()
export class NetworkProductConfigurationParser extends AbstractParser<NetworkProductConfigurationCluster> {
  parse(payload: any): NetworkProductConfigurationCluster {
    const networkProductConfiguration = new NetworkProductConfigurationCluster();
    networkProductConfiguration.setKey(payload.Key);
    networkProductConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    networkProductConfiguration.setAllNetworks(payload.AllNetworks);
    networkProductConfiguration.setNetworkSelectedList(this.parseNetwork(payload.NetworkFiscalNumbers));
    networkProductConfiguration.setNetworkSelectedListPrev(this.parseNetwork(payload.Networks));
    networkProductConfiguration.setNetworkDetails(this.parseNetworkies(payload.Networks));
    networkProductConfiguration.setPriceIntegration(payload.PriceIntegration);

    return networkProductConfiguration;
  }

  private parseNetwork(payload: any): Network[] {
    const networkSelectedList: Network[] = payload.map((networkFiscalNumber) => {
      const network = new Network();
      network.setFiscalNumber(networkFiscalNumber); 
      return network;
    });

    return networkSelectedList;
  }

  private parseNetworkies(payload: any): Network[] {
    const networkDetails: Network[] = payload.map((item) => {
      const network = new Network();
      network.setFiscalNumber(item.FiscalNumber);
      network.setCorporateName(item.CorporateName);
      network.setTradingName(item.TradingName);

      return network;
    });

    return networkDetails;
  }
}
